import script from "./WinBackViewV2.vue?vue&type=script&setup=true&lang=js"
export * from "./WinBackViewV2.vue?vue&type=script&setup=true&lang=js"

import "./WinBackViewV2.vue?vue&type=style&index=0&id=27a8694d&lang=scss"

const __exports__ = script;

export default __exports__